import {
  Chip,
  DownIcon,
  FilterIcon,
  GKButton,
  Grid2,
  Popover,
  Typography,
  UpIcon,
} from "components";
import { FilterType } from "interfaces/OrderSimulation";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { numberToCurrency } from "utils";
import { PortfolioGroupFilter, SliderFilter } from "./Filters";

const FilterPopover = () => {
  const [activeFilterType, setActiveFilterType] = useState<FilterType | null>(
    null,
  );
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const form = useFormContext();

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    filterType: FilterType,
  ) => {
    setAnchorEl(event.currentTarget);
    setActiveFilterType(filterType);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveFilterType(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Grid2 container spacing={1}>
        <Grid2 size={12} display={"flex"} gap={1} alignItems={"center"}>
          <Typography
            fontSize={12}
            fontWeight={500}
            color="#4F4F4F"
            display={"flex"}
            gap={1}
            alignItems={"center"}
          >
            <FilterIcon />
            Filters:
          </Typography>
          <GKButton
            variant="outlined"
            color="dark"
            endIcon={
              activeFilterType === "portfolio_group" && open ? (
                <UpIcon width={16} height={16} />
              ) : (
                <DownIcon width={16} height={16} />
              )
            }
            onClick={(e) => handleClick(e, "portfolio_group")}
          >
            <Typography
              fontSize={12}
              fontWeight={500}
              color="#4F4F4F"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Portfolio Group
              {form.getValues("portfolioSelectionFilter.portfolio_group")
                .length !== 0 && (
                <Chip
                  label={
                    form.getValues("portfolioSelectionFilter.portfolio_group")
                      .length
                  }
                />
              )}
            </Typography>
          </GKButton>
          <GKButton
            variant="outlined"
            color="dark"
            endIcon={
              activeFilterType === "portfolio_value" && open ? (
                <UpIcon width={16} height={16} />
              ) : (
                <DownIcon width={16} height={16} />
              )
            }
            onClick={(e) => handleClick(e, "portfolio_value")}
          >
            <Typography
              fontSize={12}
              fontWeight={500}
              color="#4F4F4F"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Portfolio Value
              {form.getValues("portfolioSelectionFilter.portfolio_value")
                .length !== 0 && (
                <Typography fontSize={12} fontWeight={600}>
                  {numberToCurrency(
                    form.getValues(
                      "portfolioSelectionFilter.portfolio_value",
                    )[0],
                  )}{" "}
                  -{" "}
                  {numberToCurrency(
                    form.getValues(
                      "portfolioSelectionFilter.portfolio_value",
                    )[1],
                  )}
                </Typography>
              )}
            </Typography>
          </GKButton>
          <GKButton
            variant="outlined"
            color="dark"
            endIcon={
              activeFilterType === "available_cash" && open ? (
                <UpIcon width={16} height={16} />
              ) : (
                <DownIcon width={16} height={16} />
              )
            }
            onClick={(e) => handleClick(e, "available_cash")}
          >
            <Typography
              fontSize={12}
              fontWeight={500}
              color="#4F4F4F"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Available Cash
              {form.getValues("portfolioSelectionFilter.available_cash")
                .length !== 0 && (
                <Typography fontSize={12} fontWeight={600}>
                  {numberToCurrency(
                    form.getValues(
                      "portfolioSelectionFilter.available_cash",
                    )[0],
                  )}{" "}
                  -{" "}
                  {numberToCurrency(
                    form.getValues(
                      "portfolioSelectionFilter.available_cash",
                    )[1],
                  )}
                </Typography>
              )}
            </Typography>
          </GKButton>
        </Grid2>
      </Grid2>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{ paper: { sx: { width: "320px", borderRadius: "8px" } } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Grid2 container>
          <Grid2 size={12}>
            {activeFilterType === "portfolio_group" && (
              <PortfolioGroupFilter setOpen={handleClose} />
            )}
            {activeFilterType === "portfolio_value" && (
              <SliderFilter
                setOpen={handleClose}
                formKey={"portfolioSelectionFilter.portfolio_value"}
                maxValue={100_00_00_000}
              />
            )}
            {activeFilterType === "available_cash" && (
              <SliderFilter
                setOpen={handleClose}
                formKey={"portfolioSelectionFilter.available_cash"}
                maxValue={150000000}
              />
            )}
          </Grid2>
        </Grid2>
      </Popover>
    </>
  );
};

export default FilterPopover;
